<div class="container-fluid mt-3">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h4 class="mb-0">{{ title }}</h4>
    <div class="btn-group btn-group-sm" *ngIf="!loading && allCases.length > 0">
      <button type="button" class="btn" [class.btn-primary]="completionFilter === 'in-progress'" [class.btn-outline-primary]="completionFilter !== 'in-progress'"
              (click)="setCompletionFilter('in-progress')">In Progress</button>
      <button type="button" class="btn" [class.btn-primary]="completionFilter === 'complete'" [class.btn-outline-primary]="completionFilter !== 'complete'"
              (click)="setCompletionFilter('complete')">Complete</button>
      <button type="button" class="btn" [class.btn-primary]="completionFilter === 'all'" [class.btn-outline-primary]="completionFilter !== 'all'"
              (click)="setCompletionFilter('all')">All</button>
    </div>
  </div>
  <p *ngIf="!loading && allCases.length > 0" class="text-muted mb-3">
    Showing {{ filteredCases.length }} of {{ allCases.length }} {{ allCases.length === 1 ? 'Case' : 'Cases' }}
  </p>

  <div *ngIf="loading" class="text-center py-5">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p class="mt-2 text-muted">Loading cases...</p>
  </div>

  <ng-container *ngIf="!loading && allCases.length > 0">
    <div class="d-flex mb-3 filter-row">
      <div class="filter-wide" *ngIf="showCandidateSearch">
        <label class="text-xs">Candidate</label>
        <div class="d-flex align-items-center">
          <input class="form-control" [formControl]="candidateSearch" placeholder="Search candidate" autocomplete="off">
          <i class="fa fa-times-circle text-muted cursor-pointer filter-clear" [class.invisible]="!hasSearch"
             (click)="candidateSearch.reset()" title="Clear"></i>
        </div>
      </div>
      <div class="filter-wide">
        <label class="text-xs">Type</label>
        <div class="d-flex align-items-center">
          <mat-select [formControl]="typeFilter" class="form-control" multiple>
            <mat-option *ngFor="let t of distinctTypes" [value]="t">{{ getWorkflowDisplayName(t) }}</mat-option>
          </mat-select>
          <i class="fa fa-times-circle text-muted cursor-pointer filter-clear" [class.invisible]="!hasTypeFilter"
             (click)="typeFilter.reset([])" title="Clear"></i>
        </div>
      </div>
      <div class="filter-wide" *ngIf="completionFilter !== 'complete'">
        <label class="text-xs">Status</label>
        <div class="d-flex align-items-center">
          <mat-select [formControl]="statusFilter" class="form-control" multiple>
            <mat-option *ngFor="let s of availableStatuses" [value]="s">{{ s }}</mat-option>
          </mat-select>
          <i class="fa fa-times-circle text-muted cursor-pointer filter-clear" [class.invisible]="!hasStatusFilter"
             (click)="statusFilter.reset([])" title="Clear"></i>
        </div>
      </div>
      <div class="filter-narrow">
        <label class="text-xs">Year</label>
        <div class="d-flex align-items-center">
          <mat-select [formControl]="yearFilter" class="form-control" multiple>
            <mat-option *ngFor="let y of distinctYears" [value]="y">{{ formatYear(y) }}</mat-option>
          </mat-select>
          <i class="fa fa-times-circle text-muted cursor-pointer filter-clear" [class.invisible]="!hasYearFilter"
             (click)="yearFilter.reset([])" title="Clear"></i>
        </div>
      </div>
    </div>

    <table class="table table-hover">
      <thead class="thead-light">
        <tr>
          <th class="cursor-pointer" (click)="toggleSort('candidateName')">
            Candidate <i class="fa" [ngClass]="getSortIcon('candidateName')"></i>
          </th>
          <th class="cursor-pointer" (click)="toggleSort('workflowType')">
            Type <i class="fa" [ngClass]="getSortIcon('workflowType')"></i>
          </th>
          <th class="cursor-pointer" (click)="toggleSort('statusSummary')">
            Status <i class="fa" [ngClass]="getSortIcon('statusSummary')"></i>
          </th>
          <th class="cursor-pointer" (click)="toggleSort('periodOfReviewId')">
            Year <i class="fa" [ngClass]="getSortIcon('periodOfReviewId')"></i>
          </th>
          <th class="cursor-pointer" (click)="toggleSort('createdAt')">
            Created <i class="fa" [ngClass]="getSortIcon('createdAt')"></i>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of filteredCases">
          <td>
            <a class="text-primary cursor-pointer" (click)="viewPacket(c)">
              {{ c.candidateName }}
            </a>
          </td>
          <td>{{ getWorkflowDisplayName(c.workflowType) }}</td>
          <td>
            <span class="badge" [ngClass]="getStatusClass(c.status)">
              {{ c.statusSummary }}
            </span>
          </td>
          <td>{{ formatYear(c.periodOfReviewId) }}</td>
          <td>{{ c.createdAt | date:'mediumDate' }}</td>
          <td class="text-right">
            <button class="btn btn-sm btn-outline-secondary" (click)="viewPacket(c)">
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="filteredCases.length === 0" class="text-center py-4">
      <p class="text-muted">No cases match the selected filters.</p>
    </div>
  </ng-container>

  <div *ngIf="!loading && allCases.length === 0" class="text-center py-5">
    <i class="fa fa-inbox fa-3x text-muted"></i>
    <p class="mt-2 text-muted">{{ emptyMessage }}</p>
  </div>
</div>
